"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ReportReviewModal = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/modals/ReportReviewModal"));

var _ReportReasons = require("ecosystem-marketplace-core/constants/reviews/ReportReasons");

var _ReviewsActions = require("../../../actions/ReviewsActions");

var _auth = require("../../../selectors/auth");

var withReportModalState = function withReportModalState(WrappedComponent) {
  return function (props) {
    var review = props.review;

    var _useState = (0, _react.useState)(false),
        _useState2 = (0, _slicedToArray2.default)(_useState, 2),
        reviewModalOpen = _useState2[0],
        setReviewModalOpen = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
        replyModalOpen = _useState4[0],
        setReplyModalOpen = _useState4[1];

    var dispatch = (0, _reactRedux.useDispatch)();
    var isCustomer = (0, _reactRedux.useSelector)(_auth.getIsCustomer);

    var onReviewModalOpen = function onReviewModalOpen() {
      return setReviewModalOpen(true);
    };

    var onReplyModalOpen = function onReplyModalOpen() {
      return setReplyModalOpen(true);
    };

    var onReviewModalClose = function onReviewModalClose() {
      return setReviewModalOpen(false);
    };

    var onReplyModalClose = function onReplyModalClose() {
      return setReplyModalOpen(false);
    };

    var buildReportModal = (0, _react.useCallback)(function (type, onConfirm, onClose) {
      return _react.default.createElement(_ReportReviewModal.default, {
        review: review,
        type: type,
        onClose: onClose,
        onConfirm: onConfirm
      });
    }, [review]);

    var onReviewModalConfirm = function onReviewModalConfirm(reason, comment) {
      dispatch((0, _ReviewsActions.reportReview)({
        reviewId: review.get('id'),
        reason: reason,
        comment: comment
      }));
      onReviewModalClose();
    };

    var onReplyModalConfirm = function onReplyModalConfirm(reason, comment) {
      dispatch((0, _ReviewsActions.reportReply)({
        reviewId: review.get('id'),
        replyId: review.getIn(['reply', 'id']),
        reason: reason,
        comment: comment
      }));
      onReplyModalClose();
    };

    var reportReviewModal = buildReportModal(_ReportReasons.Reportables.REVIEW, onReviewModalConfirm, onReviewModalClose);
    var reportReplyModal = buildReportModal(_ReportReasons.Reportables.REPLY, onReplyModalConfirm, onReplyModalClose);
    return _react.default.createElement(WrappedComponent, (0, _extends2.default)({}, props, {
      isCustomer: isCustomer,
      onReviewModalOpen: onReviewModalOpen,
      onReplyModalOpen: onReplyModalOpen,
      reviewModalOpen: reviewModalOpen,
      replyModalOpen: replyModalOpen,
      reportReviewModal: reportReviewModal,
      reportReplyModal: reportReplyModal
    }));
  };
};

var _default = withReportModalState;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/reviews/withReportModalState.js
// module id = 426
// module chunks = 209 210 211 212